import type { ApiResponse } from "@/types";

import { BaseApi } from "../base.api";
import type { Reading, UpsertReadingData } from "./types";

export * from "./types";

/** O'qish kontenti API — backend'dagi `ReadingsController` ning ko'zgusi. */
export class ReadingsApi extends BaseApi {
  private url(lessonId: number): string {
    return `/lessons/${lessonId}/reading`;
  }

  /** Hali kontent bo'lmasa 404 — kutilgan holat, toast ko'rsatilmaydi. */
  getByLesson(lessonId: number) {
    return this.request.get<Reading, ApiResponse<Reading>>(this.url(lessonId), {
      skipErrorToast: true,
    });
  }

  upsert(lessonId: number, data: UpsertReadingData) {
    return this.request.put<Reading, ApiResponse<Reading>>(this.url(lessonId), data);
  }

  addAttachments(lessonId: number, files: File[], onProgress?: (percent: number) => void) {
    const formData = new FormData();
    files.forEach(file => formData.append("files", file));
    return this.request.post<Reading, ApiResponse<Reading>>(
      `${this.url(lessonId)}/attachments`,
      formData,
      {
        onUploadProgress: event => {
          if (onProgress && event.total) {
            onProgress(Math.round((event.loaded * 100) / event.total));
          }
        },
      },
    );
  }

  remove(lessonId: number) {
    return this.request.delete<null, ApiResponse<null>>(this.url(lessonId));
  }
}

export const readingsApi = new ReadingsApi();
